<div class="container">
    <div class="row mt-3 mb-3">
        <div class="col">
            <div class="card">
                <form [formGroup]="deviceManufacturerFormGroup" (ngSubmit)="onDeviceManufacturerFormSubmit()">
                    <div class=" card-header ">
                        Device Manufacturer
                    </div>
                    <div class="card-body ">
                        <dl class="row ">
                            <dt class="col-sm-3 text-right align-middle ">
                                <label class="control-label col-form-label-sm ">device manufacturer name *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm" [ngClass]="{ 'is-invalid': validationErrorsArray['name'] }" formControlName="name" />
                                <div *ngIf="validationErrorsArray['name']" class="invalid-feedback">
                                    {{validationErrorsArray['name']}}
                                </div>
                            </dd>
                        </dl>
                    </div>
                    <div class="card-footer ">
                        <a class="btn btn-default btn-sm " href="/hardware/devices ">
                            <i class="fa fa-times "></i> <br /> Cancel
                        </a>
                        <button class="btn btn-primary btn-sm float-right " type="submit ">
                            <i class="fa fa-save "></i> <br />
                            Save
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>